import {memo, useEffect, useState} from 'react'
import memberServices from '../../services/MemberService';
import { get } from "lodash";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import Constants from "../../common/Constants";

const ZendeskListener = inject("AccountStore", "LayoutTemplateStore")(
  observer(({ AccountStore, LayoutTemplateStore }) => {
  const loginId  = get(AccountStore, 'user.loginId', '');
  const currentPageContainer = get(LayoutTemplateStore, 'currentPageContainer', '');
  const [openChat, setOpenChat] = useState(false)

  useEffect(() => {
    if (!loginId) return
    try {
      window.zE('messenger:on', 'open', async () => {
          setOpenChat(true)
      })
    } catch (e) {
        console.error('Can not open Zendesk chat: ', e)
    }
  }, [loginId])
  
  useEffect(() => {
    const shouldHide = currentPageContainer === Constants.PAGE_NAME.ODDS_PAGE_CONTAINER
    try {
      window.zE('messenger', shouldHide ? 'hide' : 'show');
    } catch (e) {
      const launchZendesk = document.querySelector('#launcher')
      if (launchZendesk) {
        launchZendesk.style.display = shouldHide ? 'none' : 'block'
      }
    }
  }, [currentPageContainer]);

  useEffect( () => {
    if (!openChat) return
    async function signInZendesk() {
      const token = await memberServices.getZendeskToken({loginId})
      if (token.data) {
        try {
          return window.zE('messenger', 'loginUser', function (callback) {
            callback(token.data)
          })
        } catch (e) {
          console.error('Can not send the loginId to Zendesk: ', e)
        }
      }
    }

    signInZendesk();
  }, [openChat])

  return null
  })
);

export default memo(ZendeskListener)





// WEBPACK FOOTER //
// ./src/app/components/ZendeskListener/index.js